<template>
  <v-container class="wizard-wrapper">
    <div class="title my-4 text-center">Find Great Things To Do Where You Live!</div>
    <v-layout row wrap align-center>
      <v-flex xs12 sm4 lg3 form-wrapper>
        <v-form ref="form" v-model="valid" lazy-validation class="mb-4">
          <v-layout row wrap align-center justify-center>
            <v-flex xs12>
              <div class="subtitle-1 font-weight-bold">Which site?</div>
            </v-flex>
          </v-layout>

          <v-layout row wrap align-center justify-start>
            <v-flex xs12>
              <v-radio-group row v-model="site" :error-messages="siteErrors">
                <v-radio :label="item.label" :value="item.domain" v-for="(item, index) in sites"></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>

          <v-layout row wrap align-center justify-start>
            <v-flex xs12>
              <div class="subtitle-1 font-weight-bold">Your Location</div>
            </v-flex>
          </v-layout>

          <v-layout row wrap align-center justify-start>
            <v-flex xs12>
              <v-text-field
                v-model="postalcode"
                label="Postal Code"
                :error-messages="postalErrors"
                placeholder="Type in your postal code"
                color="cyan darken"
                outline
                loading
              >
                <v-progress-linear slot="progress" :value="progress" :color="color" height="7"></v-progress-linear>
              </v-text-field>
              <div class="display">{{city}}</div>
            </v-flex>
          </v-layout>

          <v-flex xs12 pb-4 justify-start>
            <v-divider></v-divider>
          </v-flex>

          <v-layout row wrap align-center justify-start>
            <v-flex xs12>
              <v-select
                v-model="state"
                :hint="`${state.state} ${state.abbr}`"
                :items="states"
                item-text="state"
                item-value="abbr"
                label="State/Province"
                placeholder="Select State"
                persistent-hint
                return-object
                outline
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap align-center justify-start>
            <v-flex xs12>
              <v-select
                v-model="region"
                :hint="`${region.name}`"
                :items="regions"
                item-text="name"
                item-value="name"
                label="Region"
                placeholder="Select region"
                persistent-hint
                return-object
                outline
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap align-center justify-start>
            <v-flex xs12>
              <v-btn color="primary" @click.native="navigateToSite()" block>Submit</v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>

      <v-flex xs12 sm8 mb-4 map-wrapper>
        <img src="./../assets/map.png" class="map" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import {
  required,
  maxLength,
  email,
  integer,
  requiredIf
} from "vuelidate/lib/validators";
import $ from "jquery";
import states from "../data/Regions";
export default {
  name: "ET",
  mixins: [validationMixin],
  validations: {
    postalcode: {
      required: requiredIf(function(nestedModel) {
        return nestedModel.state.abbr == "" ? true : false;
      }),
      maxLength: maxLength(7)
    },
    site: {
      required: required
    }
  },

  data: () => ({
    states: states,
    postalcode: "",
    city: "",
    state: { state: "", abbr: "" },
    region: { name: "", domain: "" },
    site: "",
    valid: true
  }),
  computed: {
    progress() {
      return Math.min(50, this.postalcode.length * 10);
    },
    color() {
      return ["error", "warning", "success"][Math.floor(this.progress / 25)];
    },
    regions() {
      var states = this.states;
      var state = this.state;
      for (var i = 0; i < states.length; i++) {
        if (states[i].abbr == state.abbr) {
          return states[i].regions;
        }
      }
    },
    postalErrors() {
      const errors = [];
      if (!this.$v.postalcode.$dirty) return errors;
      !this.$v.postalcode.maxLength &&
        errors.push(
          "Postal code should be a maximum of 5 characters for the U.S. and 7 characters for Canada"
        );
      !this.$v.postalcode.required &&
        errors.push(
          "Postal code is required unless you select state and region."
        );
      return errors;
    },
    siteErrors() {
      const errors = [];
      if (!this.$v.site.$dirty) return errors;
      !this.$v.site.required && errors.push("Event Type is required.");
      return errors;
    }
  },
  methods: {
    onComplete: function() {},
    validatesecondStep() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      } else {
        return true;
      }
    },
    navigateToSite() {
      if (this.validatesecondStep() && this.region.domain != "") {
        var url = "https://" + this.region.domain + "." + this.site;
        window.open(url, "_blank");
      }
    },
    setSite(domain) {
      this.site = domain;
    },

    getCity: function(s) {
      let self = this;
      var geocoder = new google.maps.Geocoder();

      var address = this.postalcode + "," + s;

      geocoder.geocode({ address: address }, function(results, status) {
        if (
          status == google.maps.GeocoderStatus.OK &&
          results[0].types.indexOf("postal_code") > -1
        ) {
          var latitude = results[0].geometry.location.lat();
          var longitude = results[0].geometry.location.lng();
          var d = { lat: latitude, lon: longitude };

          self.city = results[0].formatted_address;
          $(".display").addClass("animated fadeInDown");
          var currDist = { region: "", state: "", dist: 0 };
          self.states.forEach(function(state, index) {
            state.regions.forEach(function(region, index) {
              var dist = self.getdistance(d, region.center);
              if (dist < currDist.dist || currDist.dist == 0) {
                currDist.dist = dist;
                currDist.state = state;
                currDist.region = region;
              }
            });
          });
          self.state = currDist.state;
          self.region = currDist.region;
        } else {
          self.city =
            "We couldn't find your location based on the provided Postal code. Please select your region manually";
          $(".display").addClass("animated fadeInDown");
        }
      });
    },
    rad: function(x) {
      return (x * Math.PI) / 180;
    },
    getdistance: function(p1, p2) {
      var R = 6378137; // Earth’s mean radius in meter
      var dLat = this.rad(p2.lat - p1.lat);
      var dLong = this.rad(p2.lon - p1.lon);
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.rad(p1.lat)) *
          Math.cos(this.rad(p2.lat)) *
          Math.sin(dLong / 2) *
          Math.sin(dLong / 2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var d = R * c;
      return d; // returns the distance in meter
    }
  },
  watch: {
    postalcode: function() {
      if (this.postalcode.length === 5) {
        this.getCity("US");
      }
      if (this.postalcode.length === 6 || this.postalcode.length === 7) {
        this.getCity("CA");
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.subtitle-1 {
  color: #06aaa0;
  font-weight: bold;
  margin-bottom: 15px;
  font-size: 16px;
}

.horizontal-separator {
  margin: -15px auto 0 auto;
  text-align: center;
  display: block;
  width: 30px;
  line-height: 30px;
  background: rgb(0, 185, 180);
  border-radius: 50%;
  color: #fff;
}

.vue-form-wizard {
  padding-bottom: 0;
}

.vue-form-wizard .wizard-tab-content {
  padding-left: 0 !important;
  padding-right: 0 !important;
  background: #fff;
  margin-top: 10px;
  margin-bottom: 20px;
}

.v-input--radio-group {
  margin-top: 0;
  padding-top: 0;
}

.v-input--radio-group .v-input__slot {
  margin: 0;
}

.wizard-wrapper .v-radio {
  margin-bottom: 10px;
}
.wizard-wrapper .accent--text {
	color: #06aaa0 !important;
}

.wizard-wrapper label.v-label {
	color: #000;
  font-size: 13px;

}

.wizard-wrapper .v-text-field--outline .v-input__slot {
	border-color: #d9dfe0;
}

.wizard-wrapper .v-radio .v-icon {
	color: #d9dfe0;
}

.wizard-wrapper .v-select .v-icon {
	color: #000;
}

.wizard-wrapper button {
  border-radius: 5px;
  height: 45px;
  font-size: 17px;
}

.wizard-wrapper button .v-btn__content::after {
  content: ' ';
  display: inline-block;
  position: relative;
  margin-left: 5px;
  border-style: solid;
  border-color: #fff;
	border-width: 3px 3px 0 0;
	display: inline-block;
	height: 8.5px;
  width: 8.5px;
	transform: rotate(45deg);
	vertical-align: top;
}

@media screen and (min-width: 600px) {
  .subtitle-1 {
    font-size: 18px;
  }

  .map-wrapper {
    padding-left: 40px;
    padding-top: 40px;
  }

  .form-wrapper {
    padding-right: 20px;
  }
}

@media screen and (min-width: 1024px) {
	.subtitle-1 {
    font-size: 20px;
  }
}

.text-center {
  text-align: center;
}
</style>
